import React from "react";
import { EventLanguage, OrderLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import OrderUserSection from "./OrderUserSection";
import { trimString } from "../../utils/Helper";

const BillingSection = ({ loading, error, details }) => {
  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <div className="row g-4 event-order-detail-middle">
        <div className="col-lg-6">
          <section
            className="event-order-detail-billing"
            aria-label="Billing information"
          >
            <h3 className="event-order-detail-section-title">
              {OrderLanguage.OrderDetails.billingSection.heading}
            </h3>
            <OrderUserSection
              isError={error}
              isLoading={loading}
              details={details}
            />
          </section>
        </div>
        <div className="col-lg-6">
          <section
            className="event-order-detail-summary-card"
            aria-label="Order summary"
          >
            <h3 className="event-order-detail-summary-title">
              {OrderLanguage.OrderDetails.billingSection.orderSummery.heading}
            </h3>
            <div className="event-order-detail-summary-table-wrap">
              <table className="event-order-detail-summary-table">
                <thead>
                  <tr>
                    <th scope="col">Ticket Type</th>
                    <th scope="col">Qty.</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Payment Type</th>
                  </tr>
                </thead>
                <tbody>
                  {details?.tickets?.length ? (
                    details.tickets.map((ticket, index) => (
                      <tr key={index}>
                        <td>{trimString(ticket.name, 20)}</td>
                        <td>{ticket.quantity}</td>
                        <td>USD {(ticket.quantity * ticket.price).toFixed(2)}</td>
                        <td>
                          {details?.paymentType === "emi"
                            ? "Split"
                            : details?.paymentType}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="event-order-detail-empty">
                        No ticket information available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <dl className="event-order-detail-totals">
              <div className="event-order-detail-total-row">
                <dt>{EventLanguage.UserEvents.ticket.Saving}</dt>
                <dd>
                  -USD {parseFloat(details?.discount || 0).toFixed(2)}
                </dd>
              </div>
              <div className="event-order-detail-total-row">
                <dt>{EventLanguage.UserEvents.ticket.Subtotal}</dt>
                <dd>USD {parseFloat(details?.subtotal || 0).toFixed(2)}</dd>
              </div>
              <div className="event-order-detail-total-row">
                <dt>Service Fee</dt>
                <dd>
                  +USD {parseFloat(details?.serviceFee || 0).toFixed(2)}
                </dd>
              </div>
              <div className="event-order-detail-total-row is-grand-total">
                <dt>{EventLanguage.UserEvents.ticket.Total}</dt>
                <dd>USD {parseFloat(details?.total || 0).toFixed(2)}</dd>
              </div>
            </dl>
          </section>
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default BillingSection;
